import * as React from "react"
import type { SVGProps } from "react"
const SvgColumns = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M15 19.85V5.86h4v14zm-10 0V5.86h4v14zm8.59 1.42q.58.6 1.41.59h4q.83 0 1.41-.59.6-.6.59-1.41v-14q0-.82-.59-1.42A2 2 0 0 0 19 3.86h-4q-.83 0-1.41.59a2 2 0 0 0-.59 1.4v14q0 .84.59 1.42m-10 0q.59.6 1.41.59h4q.82 0 1.41-.59.6-.6.59-1.41v-14q0-.82-.59-1.42A2 2 0 0 0 9 3.86H5q-.82 0-1.41.59A2 2 0 0 0 3 5.85v14q0 .84.59 1.42"
    />
  </svg>
)
export default SvgColumns
